import { FormikHelpers } from 'formik';

export function handleFormikSubmit(values: any, helpers: FormikHelpers<any>) {
    helpers.setSubmitting(false);
    helpers.resetForm({ values });
}
